namespace TabAurous.OMS {
    export interface TaxItemDetailsRow {
        TaxItemDetailsId?: number;
        TaxId?: number;
        GroupId?: number;
        BaseItemTypeId?: number;
    }

    export namespace TaxItemDetailsRow {
        export const idProperty = 'TaxItemDetailsId';
        export const localTextPrefix = 'OMS.TaxItemDetails';
        export const deletePermission = 'Masters:Tax:Delete';
        export const insertPermission = 'Masters:Tax:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:Tax:Edit';

        export declare const enum Fields {
            TaxItemDetailsId = "TaxItemDetailsId",
            TaxId = "TaxId",
            GroupId = "GroupId",
            BaseItemTypeId = "BaseItemTypeId"
        }
    }
}
